import z from "zod";

export const diagnosticObjectivePieceSchema = z.object({
  description: z.string(),
  unit_price: z.string(),
  quantity: z.string(),
  warranty_in_days: z.string(),
});

export type DiagnosticObjectivePieceValidationSchema = z.infer<typeof diagnosticObjectivePieceSchema>;
